import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=459b97ed&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459b97ed')) {
      api.createRecord('459b97ed', component.options)
    } else {
      api.reload('459b97ed', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=459b97ed&", function () {
      api.rerender('459b97ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Carousel.vue"
export default component.exports